import { render, staticRenderFns } from "./adjustmenetImage.vue?vue&type=template&id=c2046788"
import script from "./adjustmenetImage.vue?vue&type=script&lang=js"
export * from "./adjustmenetImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports